import React, { memo } from 'react';
import { ArrowLeft } from 'lucide-react';
import { motion } from 'motion/react';

import { Button } from '@repo/ui/components/ui/button';

interface YtVideoCardAnalysisCloseProps {
  setIsVisible: (isVisible: boolean) => void;
}

const PureYtVideoCardAnalysisClose: React.FC<YtVideoCardAnalysisCloseProps> = ({
  setIsVisible,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className="absolute top-1/2 -translate-x-full -translate-y-1/2 transition-transform"
    >
      <Button
        type="button"
        variant="ghost"
        onClick={() => setIsVisible(false)}
        className="h-[59px] cursor-pointer gap-0.5 rounded-lg rounded-r-none bg-[#F2F2F2] px-2 py-3 shadow-[0px_1.95px_9.77px_0px_rgba(0,0,0,0.25)] transition-[padding,background-color,color] duration-300 ease-in-out hover:bg-[#e6e4e4] hover:text-accent dark:bg-background dark:text-primary cred-md:h-16 cred-md:px-2.5 cred-md:py-3.5 cred-lg:h-[68px] cred-lg:px-3 cred-lg:py-4 cred-xl:h-[72px] cred-xl:px-4 cred-xl:py-[18px]"
      >
        <span className="sr-only">Toggle side panel</span>
        <ArrowLeft className="h-[21.5px]! w-auto transition-[colors,transform] duration-500 cred-md:h-[22px] cred-lg:h-[23px] cred-xl:h-6 text-[#2D3748]/90 [transform:rotateY(180deg)]" />
      </Button>
    </motion.div>
  );
};
export const YtVideoCardAnalysisClose = memo(PureYtVideoCardAnalysisClose);
